import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SafetyPage from "./pages/SafetyPage";
import AdminPage from "./pages/AdminPage";
import CatalogPage from "./pages/CatalogPage";
import UngatingPage from "./pages/UngatingPage";
import SupplierInvoicePage from "./pages/SupplierInvoicePage";
import SourcingPackPage from "./pages/SourcingPackPage";
import AsinCheckerPage from "./pages/AsinCheckerPage";
import RepricerPage from "./pages/RepricerPage";
import WebsitePage from "./pages/WebsitePage";
import CriticalMistakesPage from "./pages/CriticalMistakesPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import CheckLeadPage from "./pages/CheckLeadPage";
import CheckerPage from "./pages/CheckerPage";
import ResultsPage from "./pages/ResultsPage";
import { MyselfPage, PotokPage, AdvancedPage, VipPage,
         DiscountMyselfPage, DiscountPotokPage, DiscountAdvancedPage, DiscountVipPage } from "./pages/TierDetailPage";
import ShortLinkRedirect from "./pages/ShortLinkRedirect";
import { useVisitorTracking } from "./hooks/useVisitorTracking";
import { PricesProvider } from "./context/PricesContext";
import { PromoProvider } from "./context/PromoContext";

// Wrapper component for tracking
const TrackingWrapper = ({ children }) => {
  useVisitorTracking();
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <PricesProvider>
        <PromoProvider>
          <TrackingWrapper>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/faster_discount" element={<LandingPage discountMode={true} />} />
              <Route path="/discount" element={<LandingPage discountMode={true} />} />
              <Route path="/safety" element={<SafetyPage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/catalog/ungating" element={<UngatingPage />} />
              <Route path="/catalog/supplier-invoice" element={<SupplierInvoicePage />} />
              <Route path="/catalog/sourcing-pack" element={<SourcingPackPage />} />
              <Route path="/catalog/asin-checker" element={<AsinCheckerPage />} />
              <Route path="/catalog/repricer" element={<RepricerPage />} />
              <Route path="/catalog/website" element={<WebsitePage />} />
              <Route path="/catalog/critical-mistakes" element={<CriticalMistakesPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/check_lead" element={<CheckLeadPage />} />
              <Route path="/check_lead/:source" element={<CheckLeadPage />} />
              <Route path="/checker" element={<CheckerPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/myself" element={<MyselfPage />} />
              <Route path="/potok" element={<PotokPage />} />
              <Route path="/advanced" element={<AdvancedPage />} />
              <Route path="/vip" element={<VipPage />} />
              <Route path="/discount/myself"   element={<DiscountMyselfPage />} />
              <Route path="/discount/potok"    element={<DiscountPotokPage />} />
              <Route path="/discount/advanced" element={<DiscountAdvancedPage />} />
              <Route path="/discount/vip"      element={<DiscountVipPage />} />
              <Route path="/s/:code" element={<ShortLinkRedirect />} />
            </Routes>
          </TrackingWrapper>
        </PromoProvider>
      </PricesProvider>
    </BrowserRouter>
  );
}

export default App;
